import Main from "./pages/Main";
import FileInfo from "./pages/FileInfo";
import Auth from "./pages/Auth";
import Greeting from "./pages/Greeting";
import SubjectInfo from "./pages/SubjectInfo";
import ResetPass from "./pages/ResetPass";
import Updates from "./pages/Updates";

export const authRoutes = [
    {path: "/", Component: Main},
    {path: "/doc", Component: Greeting},
    {path: "/updates", Component: Updates},
    {path: "/file/:id", Component: FileInfo},
    {path: "/file/:id/:subject", Component: SubjectInfo},
];

export const noAuthRoutes = [
    {path: "/", Component: Greeting},
    {path: "/login", Component: Auth},
    {path: "/register", Component: Auth},
    {path: "/reset/:hash", Component: ResetPass},
];